<div class="d-flex flex-column table-container background-container mt-4">
  <!-- Header - Sticky -->
  <div class="header-box">
    <div class="fixed-with-coloumn p-2" *ngFor="let name of columnDisplayNames">
      {{ name }}
    </div>
  </div>

  <!-- Scrollable Table Body -->
  <div class="table-body-container">
    <div class="d-flex flex-column gap-1" *ngFor="let item of paginatedData">
      @if(tableFrom == 'DIST'){
      <div class="information-box border-colour" [ngClass]="getBorderClass(item)"
        (click)="openPatientProfileDistributor(item);$event.stopPropagation();">

        <div class="fixed-with-coloumn p-2">
          <div class="fullname-wrapper gray-text">
            <div>{{ item.firstName }} {{ item.lastName }}</div>
            <div class="gray-text fs-11 mt-1">
              {{ item.dateOfBirth | age }}, {{ item.gender?.charAt(0) }}
            </div>
          </div>
        </div>
        <div class="fixed-with-coloumn p-2 gray-text"> {{item.email}} </div>
        <div class="fixed-with-coloumn p-2 gray-text"> {{item.phone}} </div>


        <div class="fixed-with-coloumn p-2 gray-text"> {{ (item?.createdon) | date:
          'dd/MM/yyyy HH:mm' }}
        </div>

        <div class="fixed-with-coloumn p-2 gray-text"> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
            viewBox="0 0 24 24">
            <path fill="#595959"
              d="M17.438 21.937H6.562a2.5 2.5 0 0 1-2.5-2.5v-.827c0-3.969 3.561-7.2 7.938-7.2s7.938 3.229 7.938 7.2v.827a2.5 2.5 0 0 1-2.5 2.5M12 12.412c-3.826 0-6.938 2.78-6.938 6.2v.827a1.5 1.5 0 0 0 1.5 1.5h10.876a1.5 1.5 0 0 0 1.5-1.5v-.829c0-3.418-3.112-6.198-6.938-6.198m0-2.501a3.924 3.924 0 1 1 3.923-3.924A3.927 3.927 0 0 1 12 9.911m0-6.847a2.924 2.924 0 1 0 2.923 2.923A2.926 2.926 0 0 0 12 3.064" />
          </svg> {{item.gender}} </div>


        <div class="fixed-with-coloumn p-2 gray-text">
          <app-status-lables [entityType]="enumEntityType.INSURER" [status]="item.status">
          </app-status-lables>
        </div>

        <div class="fixed-with-coloumn p-2 gray-text">
          <div class="action-buttons d-flex align-items-center gap-2">
            @if (!item.isactive) {
            <span class="icon-btn" matTooltip="Activate" matTooltipPosition="above"
              (click)="confirmStatusUpdate(item, true, $event)">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                <path fill="#53e643" fill-rule="evenodd"
                  d="M12 21a9 9 0 1 0 0-18a9 9 0 0 0 0 18m-.232-5.36l5-6l-1.536-1.28l-4.3 5.159l-2.225-2.226l-1.414 1.414l3 3l.774.774z"
                  clip-rule="evenodd" stroke-width="0.1" stroke="#53e643" />
              </svg>
            </span>
            } @else {
            <span class="icon-btn" matTooltip="Deactive" matTooltipPosition="above"
              (click)="confirmStatusUpdate(item, false, $event)">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 20 20">
                <path fill="#e84721" d="M10 20a10 10 0 1 1 0-20a10 10 0 0 1 0 20m5-11H5v2h10z" stroke-width="0.1"
                  stroke="#e84721" />
              </svg>
            </span>
            }
            <span class="icon-btn" matTooltip="Edit" matTooltipPosition="above"
              (click)="openPatientForm(item);$event.stopPropagation();">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 24 24">
                <path fill="#66AEE0" fill-rule="evenodd"
                  d="M21.455 5.416a.75.75 0 0 1-.096.943l-9.193 9.192a.75.75 0 0 1-.34.195l-3.829 1a.75.75 0 0 1-.915-.915l1-3.828a.8.8 0 0 1 .161-.312L17.47 2.47a.75.75 0 0 1 1.06 0l2.829 2.828a1 1 0 0 1 .096.118Z"
                  clip-rule="evenodd" stroke-width="0.1" stroke="#66AEE0" />
                <path fill="#66AEE0"
                  d="M19.641 17.16a44.4 44.4 0 0 0 .261-7.04a.4.4 0 0 1 .117-.3l.984-.984a.198.198 0 0 1 .338.127a46 46 0 0 1-.21 8.372c-.236 2.022-1.86 3.607-3.873 3.832a47.8 47.8 0 0 1-10.516 0c-2.012-.225-3.637-1.81-3.873-3.832a46 46 0 0 1 0-10.67c.236-2.022 1.86-3.607 3.873-3.832a48 48 0 0 1 7.989-.213a.2.2 0 0 1 .128.34l-.993.992a.4.4 0 0 1-.297.117a46 46 0 0 0-6.66.255a2.89 2.89 0 0 0-2.55 2.516a44.4 44.4 0 0 0 0 10.32a2.89 2.89 0 0 0 2.55 2.516c3.355.375 6.827.375 10.183 0a2.89 2.89 0 0 0 2.55-2.516Z"
                  stroke-width="0.1" stroke="#66AEE0" />
              </svg>
            </span>
          </div>
        </div>

      </div>

      }
      @else{
      <div class="information-box border-colour" [ngClass]="getBorderClass(item)"
        (click)="openPatientProfile.emit(item); $event.stopPropagation();">

        <div class="fixed-with-coloumn p-2">
          <div class="fullname-wrapper gray-text">
            <div>{{ item.firstName }} {{ item.lastName }}</div>
            <div class="gray-text fs-11 mt-1">
              {{ item.dateOfBirth | age }}, {{ item.gender?.charAt(0) }}
            </div>
          </div>
        </div>
        <div class="fixed-with-coloumn p-2 gray-text"> {{item.phone}} </div>

        <div class="fixed-with-coloumn p-2 gray-text"> {{ (item?.serviceRequest?.createdon || item?.createdon) | date:
          'dd/MM/yyyy HH:mm' }}
        </div>

        <div class="fixed-with-coloumn p-2 gray-text">
          <app-status-lables [entityType]="enumEntityType.INSURER"
            [status]="item.serviceRequest ? item.serviceRequest.status == 'SUBMITTED' ? 'RECEIVED' :item.serviceRequest.status : 'OPEN'">
          </app-status-lables>
        </div>

        <div class="fixed-with-coloumn p-2 gray-text"><ng-container
            *ngIf="item?.serviceRequest?.provider?.name; else requestME">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
              <path fill="#595959"
                d="M17.438 21.937H6.562a2.5 2.5 0 0 1-2.5-2.5v-.827c0-3.969 3.561-7.2 7.938-7.2s7.938 3.229 7.938 7.2v.827a2.5 2.5 0 0 1-2.5 2.5M12 12.412c-3.826 0-6.938 2.78-6.938 6.2v.827a1.5 1.5 0 0 0 1.5 1.5h10.876a1.5 1.5 0 0 0 1.5-1.5v-.829c0-3.418-3.112-6.198-6.938-6.198m0-2.501a3.924 3.924 0 1 1 3.923-3.924A3.927 3.927 0 0 1 12 9.911m0-6.847a2.924 2.924 0 1 0 2.923 2.923A2.926 2.926 0 0 0 12 3.064" />
            </svg>
            {{ item.serviceRequest.provider.name }}
          </ng-container>
          <ng-template #requestME>
            <div class="d-flex justify-content-center">
              <button class="primaryBtn align-items-center" style="padding: 5px 10px; font-size: 10px;"
                (click)="openRequestME.emit(item);$event.stopPropagation()">
                <span class="btnContent">Request ME</span>
              </button>
            </div>
          </ng-template>
        </div>

        <div class="fixed-with-coloumn p-2 gray-text">{{ item?.serviceRequest?.lastupdatedon || item.lastupdatedon |
          date :
          'dd/MM/yyyy HH:mm' }}</div>


        <div class="fixed-with-coloumn p-2 gray-text"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
            viewBox="0 0 24 24" *ngIf="getTurnAroundTime(item)">
            <path fill="#595959"
              d="M11.5 3a9.5 9.5 0 0 1 9.5 9.5a9.5 9.5 0 0 1-9.5 9.5A9.5 9.5 0 0 1 2 12.5A9.5 9.5 0 0 1 11.5 3m0 1A8.5 8.5 0 0 0 3 12.5a8.5 8.5 0 0 0 8.5 8.5a8.5 8.5 0 0 0 8.5-8.5A8.5 8.5 0 0 0 11.5 4M11 7h1v5.42l4.7 2.71l-.5.87l-5.2-3z" />
          </svg>
          {{ getTurnAroundTime(item) }}</div>

      </div>
      }

    </div>

    <!-- Pagination - Sticky Bottom -->
    <div class="pagination-container">
      <span class="mt-1">Pages : </span>
      <button (click)="prevPage()" [disabled]="currentPage === 1" class="pagination-btn">‹</button>

      <button *ngFor="let page of [].constructor(totalPages); let i = index" (click)="goToPage(i + 1)"
        [ngClass]="{ 'active': currentPage === i + 1 }" class="pagination-btn">
        {{ i + 1 }}
      </button>

      <button (click)="nextPage()" [disabled]="currentPage === totalPages" class="pagination-btn">›</button>
    </div>

  </div>